import { Injectable } from '@angular/core';
import { ApiService } from '@core/api/api.service';
import { HttpResponse } from '@core/api/http-response.interface';
import { CurrentUser } from '@shared/interfaces';
import { ApiHelper } from '@core/api/api.helper';
import { UserRoleEnum } from '@shared/enums';
import { HttpStatusEnum } from '@core/api/http-status.enum';

@Injectable({ providedIn: 'root' })
export class UserApi {
    constructor(private apiService: ApiService) {}

    private readonly resourceUrl: string = `users`;

    getCurrentUserDetails(): Promise<HttpResponse<CurrentUser>> {
        return new Promise<HttpResponse<CurrentUser>>(resolve => {
            this.apiService.get(`${this.resourceUrl}/current-user-details`).subscribe({
                next: (res: any) => {
                    const data: CurrentUser = {
                        id: res.userId,
                        firstName: res.firstName,
                        lastName: res.lastName,
                        shortName: res.firstName + ' ' + (res.lastName ? res.lastName[0] + '.' : ''),
                        role: res.isAdmin ? UserRoleEnum.ADMIN : UserRoleEnum.USER,
                        email: res.email,
                        hasMarketingRole: res.hasMarketingRole,
                    };
                    resolve({
                        isLoading: false,
                        status: HttpStatusEnum.SUCCESS,
                        data: data,
                    });
                },
                error: err => {
                    ApiHelper.resolveError(resolve, '');
                    console.error(err);
                },
            });
        });
    }
}
